import { api } from './api';

export interface OrgRow {
  id: string;
  name: string;
  slug: string;
  status: 'ACTIVE' | 'SUSPENDED';
  adminEmail: string;
  memberCount: number;
  projectCount: number;
  createdAt: string;
  pendingInvitationCount: number;
}

export interface OrgList {
  items: OrgRow[];
  total: number;
  limit: number;
  offset: number;
}

export interface DashboardCounts {
  organizations: number;
  users: number;
  pendingInvitations: number;
  suspendedOrgs: number;
  activeOrgs: number;
}

export interface AdminInvitationRow {
  id: string;
  email: string;
  roleId: string;
  roleName: string;
  status: 'PENDING' | 'ACCEPTED' | 'EXPIRED' | 'REVOKED';
  invitedByName: string;
  expiresAt: string;
  createdAt: string;
  attemptCount: number;
  organization: { id: string; name: string; slug: string };
}

export async function getDashboardCounts() {
  const { data } = await api.get<DashboardCounts>('/super-admin/dashboard');
  return data;
}

export interface OrgListQuery {
  search?: string;
  status?: 'ACTIVE' | 'SUSPENDED';
  limit?: number;
  offset?: number;
}

export async function listOrganizations(query: OrgListQuery = {}): Promise<OrgList> {
  const { data } = await api.get<OrgList>('/super-admin/organizations', { params: query });
  return data;
}

export interface CreateOrgBody {
  name: string;
  slug: string;
  adminEmail: string;
  adminName: string;
}

export async function createOrganization(body: CreateOrgBody) {
  const { data } = await api.post<{
    organizationId: string;
    organizationSlug: string;
    invitationId: string;
    invitationToken: string;
  }>('/super-admin/organizations', body);
  return data;
}

export async function setOrgStatus(id: string, status: 'ACTIVE' | 'SUSPENDED') {
  await api.patch(`/super-admin/organizations/${id}`, { status });
}

export async function listAdminInvitations(
  query: {
    status?: 'PENDING' | 'ACCEPTED' | 'EXPIRED' | 'REVOKED';
    limit?: number;
    offset?: number;
  } = {},
) {
  const { data } = await api.get<{
    items: AdminInvitationRow[];
    total: number;
    limit: number;
    offset: number;
  }>('/super-admin/invitations', { params: query });
  return data;
}

export async function resendAdminInvitation(id: string) {
  await api.post(`/super-admin/invitations/${id}/resend`);
}

export async function revokeAdminInvitation(id: string) {
  await api.delete(`/super-admin/invitations/${id}`);
}
